import React from 'react';
import { useBooks } from '../../hooks/useBooks';
import { db, storage } from '../../services/firebase';
import { deleteDoc, doc } from 'firebase/firestore';
import { deleteObject, ref } from 'firebase/storage';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../components/common/LoadingSpinner';

const BookList = () => {
  const { books, loading } = useBooks();

  const handleDelete = async (book) => {
    if (window.confirm(`Delete "${book.title}" permanently?`)) {
      try {
        // Delete image from storage if exists
        if (book.imageUrl) {
          const imageRef = ref(storage, book.imageUrl);
          await deleteObject(imageRef).catch(() => console.log("Image not found or already deleted"));
        }
        // Delete book document
        await deleteDoc(doc(db, "books", book.id));
        alert("Book deleted successfully");
      } catch (error) {
        alert("Error deleting book: " + error.message);
      }
    }
  };

  if (loading) return <LoadingSpinner />;

  return (
    <div>
      <h1>Manage Books</h1>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={{ backgroundColor: '#eee' }}>
            <th style={{ padding: '10px', textAlign: 'left' }}>Cover</th>
            <th>Title</th>
            <th>Author</th>
            <th>Price</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {books.map(book => (
            <tr key={book.id} style={{ borderBottom: '1px solid #ddd' }}>
              <td style={{ padding: '10px' }}>
                <img src={book.imageUrl || '/placeholder.jpg'} alt={book.title} style={{ width: '60px', height: '90px', objectFit: 'cover' }} />
              </td>
              <td>{book.title}</td>
              <td>{book.author}</td>
              <td>${book.price?.toFixed(2)}</td>
              <td>
                <Link to={`/admin/edit-book/${book.id}`} style={{ marginRight: '10px', color: '#228B22' }}>Edit</Link>
                <button onClick={() => handleDelete(book)} style={{ color: 'red', background: 'none', border: 'none', cursor: 'pointer' }}>
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BookList;